import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-invitation",
  "use": "icon-invitation-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-invitation\"><defs><style type=\"text/css\"></style></defs><path d=\"M444.2 519.9c-58.8-31.3-97.2-100.3-97.2-181.2 0-110.4 75-199.6 168-199.6s168 88.3 168 199.6c0 81-39.2 150-97.2 181.2C729.9 557.6 839 705.7 845.9 887l-661.8 0.8c8.6-179.3 117.7-330.2 260.1-367.9z m0 0\" fill=\"#d81e06\" p-id=\"4856\" /><path d=\"M654.8 161.1c38.4 45.1 63.1 107.6 63.1 176.6 0 64.4-20.5 122.4-54.6 165.6C768.2 556.7 847.5 668 873.1 803.2h150c-6-161-103.2-292.6-231.1-325.7 52-27.6 86.1-89.2 86.1-161 0-98.4-66.5-177.6-149.2-177.6-27.3 0-52.9 9.2-75 23.9l0.9-1.7z m0 0M369.2 162c-22.2-15.6-47.7-23.9-75-23.9-82.7 0-149.2 80-149.2 177.6 0 71.8 35 133.4 86.1 161C103.1 509.7 5.9 642.2 0 802.3H150.1c25.6-135.2 104.9-245.6 209.8-299.9-33.3-44.2-54.6-102.1-54.6-165.6 0-69 23.9-131.6 63.1-176.6l0.8 1.8z m0 0\" fill=\"#d81e06\" p-id=\"4857\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/invitation.svg
// module id = W6jK
// module chunks = 132